module.exports = __webpack_public_path__ + "static/media/louis-hansel-C5YnAXEEZS0-unsplash_mobile.b0a7b6cb.jpg";